import CanvasJSReact from "../../assets/js/canvasjs.react"
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
import { useContext } from "react";
import MyContext from "../MyContext";

export default function BarGraphTarget({category_targets, options, cal, amount_quantity, category_item}){
    // console.log(category_targets)
    const { loading, user_details, currency } = useContext(MyContext);

    return(
        <>
        {category_targets.length>0?
        <div className="lists_container graph_block">
                            
        <div className="chart_container" style={{height:cal+50}}>
            {/* <div className="chart_title">Target</div> */}
            <div align="center" style={{display:category_targets.length?"none":"grid"}}>No Result !</div>
            <div style={{display:category_targets.length?"grid":"none"}}>
            <CanvasJSChart options = {options}
            />
            </div>
        </div>                      
        
        <div style={{paddingTop:"15px"}}>
            <div className="yellow_shade2">
                <div className="sale_graph_container2">
                    <table className="table_list2">
                        <thead>
                            <tr>
                                <th valign="top" align="center"style={{'minWidth':'80px'}} >{category_item=='C'?'Category':'Item'}</th>
                                <th valign="top" align="center" >Target</th>
                                <th valign="top" align="center" >{amount_quantity=='Q'?'Unit':currency}</th>
                                <th valign="top" align="center" >Achieved</th>
                                <th valign="top" align="center" >Pending</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr style={{display:category_targets.length?"none":"table-row"}}>
                            <td colSpan="5" align="center">No Result !</td>
                        </tr> 
                        {category_targets.map((item,index) => (
                        <tr key={index}>
                            <td valign="bottom" ><span>{item.category_name}</span></td>
                            <td valign="bottom" align="center">
                                <span>{item.target}</span>&nbsp;
                            </td>
                            <td valign="bottom" align="center">
                                <span>{item.amount_quantity=='Q'?item.unit:''}</span>
                                {item.amount_quantity=='A'?<span>{currency}</span>:''}
                            </td>
                            <td valign="bottom" align="center">
                                <span>{item.achieved_target}</span>&nbsp;
                            </td>
                            <td valign="bottom" align="center">
                                <span>{item.pending_target}</span>&nbsp;
                            </td>
                        </tr> ))}     
                        
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        </div>:
        <div className="lists_container graph_block">No target Set</div>
        }
        </>
    )
}